import { render } from "./EventSvgTableRemoveIcon.vue?vue&type=template&id=05bb5ee2&scoped=true"
import script from "./EventSvgTableRemoveIcon.vue?vue&type=script&lang=js"
export * from "./EventSvgTableRemoveIcon.vue?vue&type=script&lang=js"

import "./EventSvgTableRemoveIcon.vue?vue&type=style&index=0&id=05bb5ee2&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05bb5ee2"]])

export default __exports__